var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBackArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 164.61 86.16",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,42.17q12.51-15.5,25-31c2.2-2.71,4.41-5.42,6.72-8C34.83-.37,38.57-1,41.23,1.61c3.06,3,2.55,6.18,0,9.3-6.92,8.29-13.8,16.6-21.46,25.82H154.89c1.66,0,3.7-.48,4.9.3,2,1.3,4.83,3.44,4.82,5.22,0,2.14-2.31,4.6-4.19,6.29-1,.87-3.19.45-4.84.45C133,49,43.71,49,19.79,49l6.05,7.3Q33,65,40.19,73.59C45,79.4,44.47,82.31,38,86.16H37C34.82,84.46,32.31,83,30.54,81,23.19,72.46,16,63.78,8.87,55.05,5.75,51.22,3,47.14,0,43.17Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back_arrow.553bdc01.svg";
export { ForwardRef as ReactComponent };